module.exports = __webpack_public_path__ + "img/2_C.b0c87d95.png";